import {
  doGet, doPost,
  doPut
} from './axiosCrud';

//User
export const login = (payload) => {
  console.log('Login endpoint - payload:', payload);
  return doPost('/Core/Login', payload);
};
//  export const login = (body) => doPost('/login', body);
export const getBot = () => doGet('/bot');
export const getRegisteredBot = () => doGet('/registered_bots');
export const getOrderStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/GetOrderStatus', payload);
};
export const createOrderStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/AddOrderStatus', payload);
};
export const updateOrderStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/UpdateOrderStatus', payload);
};
export const deleteOrderStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/DeleteOrderStatus', payload);
};
export const getStockStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/GetStockStatus', payload);
};


export const createStockStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/AddStockStatus', payload);
};

export const updateStockStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/UpdateStockStatus', payload);
};

export const deleteStockStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/DeleteStockStatus', payload);
};
export const getShipmentStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/GetShipmentStatus', payload);
};

export const createShipmentStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/AddShipmentStatus', payload);
};

export const updateShipmentStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/UpdateShipmentStatus', payload);
};

export const deleteShipmentStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/DeleteShipmentStatus', payload);
};
export const getMaterials = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/GetMaterial', payload);
};

export const createMaterial = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/AddMaterial', payload);
};

export const updateMaterial = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/UpdateMaterial', payload);
};

export const deleteMaterial = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/DeleteMaterial', payload);
};
export const getYarns = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');

  const finalPayload = {
    SessionUserId: sessionUserId,
    ...payload,
  };

  console.log('✅ GetYarn payload:', finalPayload);
  return doPost('/Definition/GetYarn', finalPayload);
};

export const createYarn = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/AddYarn', payload);
};

export const updateYarn = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/UpdateYarn', payload);
};

export const deleteYarn = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/DeleteYarn', payload);
};
export const getThreads = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');

  const finalPayload = {
    SessionUserId: sessionUserId,
    ...payload,
  };

  console.log('✅ GetThread payload:', finalPayload);
  return doPost('/Definition/GetPrdThread', finalPayload);
};

export const createThread = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/AddPrdThread', payload);
};

export const updateThread = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/UpdatePrdThread', payload);
};

export const deleteThread = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/DeletePrdThread', payload);
};
export const getColors = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');

  const finalPayload = {
    SessionUserId: sessionUserId,
    ...payload,
  };

  console.log('✅ GetColor payload:', finalPayload);
  return doPost('/Definition/GetColor', finalPayload);
};

export const createColor = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/AddColor', payload);
};

export const updateColor = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/UpdateColor', payload);
};

export const deleteColor = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/DeleteColor', payload);
};
export const getUnits = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');

  const finalPayload = {
    SessionUserId: sessionUserId,
    ...payload,
  };

  console.log('✅ GetUnit payload:', finalPayload);
  return doPost('/Definition/GetPrdUnit', finalPayload);
};

export const createUnit = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/AddPrdUnit', payload);
};

export const updateUnit = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/UpdatePrdUnit', payload);
};

export const deleteUnit = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/Definition/DeletePrdUnit', payload);
};
export const getCompositions = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  return doPost('/Definition/GetComposition', finalPayload);
};

export const createComposition = (payload) => {
  return doPost('/Definition/AddComposition', payload);
};

export const updateComposition = (payload) => {
  return doPost('/Definition/UpdateComposition', payload);
};

export const deleteComposition = (payload) => {
  return doPost('/Definition/DeleteComposition', payload);
};
export const getCurrencies = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  return doPost('/Definition/GetCurrency', finalPayload);
};

export const createCurrency = (payload) => {
  return doPost('/Definition/AddCurrency', payload);
};

export const updateCurrency = (payload) => {
  return doPost('/Definition/UpdateCurrency', payload);
};

export const deleteCurrency = (payload) => {
  return doPost('/Definition/DeleteCurrency', payload);
};
export const getWeaveTypes = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  return doPost('/Definition/GetWeaveType', finalPayload);
};

export const createWeaveType = (payload) => {
  return doPost('/Definition/AddWeaveType', payload);
};

export const updateWeaveType = (payload) => {
  return doPost('/Definition/UpdateWeaveType', payload);
};

export const deleteWeaveType = (payload) => {
  return doPost('/Definition/DeleteWeaveType', payload);
};

// SupplierType Management
export const getSupplierTypes = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  return doPost('/Definition/GetSupplierType', finalPayload);
};

export const createSupplierType = (payload) => {
  return doPost('/Definition/AddSupplierType', payload);
};

export const updateSupplierType = (payload) => {
  return doPost('/Definition/UpdateSupplierType', payload);
};

export const deleteSupplierType = (payload) => {
  return doPost('/Definition/DeleteSupplierType', payload);
};

export const signUp = (body) => doPost('/signup', body);
export const forgotPassword = (body) => doPost('/password-recovery', body);
export const resetPassword = (body) => doPost('/reset-password', body);
export const activation = (body) => doPost('/activate', body);
export const logut = (body) => doPost('/login', body);
export const getAccountDetails = (body) => doGet('/user/profile', body);
export const resendVerificationEmail = () => doPost('/user/activation-email');
export const checkUserToken = () => doGet('/user/check_token');



//Post
export const getPosts = () => doGet('/projects');
export const getPostDetails = (id) =>
  doGet('', {
    params: {
      id: id,
    },
  });



// //default
export const enable2fa = (totp_code) => doPost('/enable_2fa/' + `${totp_code}`);
export const getGenerateQR = (body) => doGet('/generate_qr');
export const verify2fa = (totp_code) => doPost('/verify_2fa/'
  + `${totp_code}`);
export const create2fa = () => doPost('/create_2fa');



// User Management
export const getUsers = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');

  const finalPayload = {
    SessionUserId: sessionUserId,
    // ...payload,
  };

  console.log('✅ GetUsers payload:', finalPayload);
  return doPost('/User/GetUserList', finalPayload);
};

export const createUser = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/User/AddUser', payload);
};

export const updateUser = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPut('/User/UpdateUser', payload);
};

export const deleteUser = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPut('/User/UpdateUser', payload);
};

// User Detail (optional - for future use)
export const getUserDetail = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/User/GetUserDetail', payload);
};

// User Status Operations (optional - for future use)
export const changeUserStatus = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/User/ChangeUserStatus', payload);
};

export const resetUserPassword = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/User/ResetPassword', payload);
};

export const changeUserPassword = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/User/ChangePassword', payload);
};

// User Permissions (optional - for future use)
export const getUserPermissions = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/User/GetUserPermissions', payload);
};

export const updateUserPermissions = (payload) => {
  console.log('Endpoint - sending payload:', payload);
  return doPost('/User/UpdateUserPermissions', payload);
};

export const getUserDetails = (data) => {
  return doPost('/User/GetUserDetails', data);
};

// Customer Management
export const getCustomer = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetCustomer payload:', finalPayload);
  return doPost('/Main/GetCustomer', finalPayload);
};

export const addCustomer = (payload) => {
  console.log('AddCustomer payload:', payload);
  return doPost('/Main/AddCustomer', payload);
};

export const updateCustomer = (payload) => {
  console.log('UpdateCustomer payload:', payload);
  return doPost('/Main/UpdateCustomer', payload);
};

export const deleteCustomer = (payload) => {
  console.log('DeleteCustomer payload:', payload);
  return doPost('/Main/DeleteCustomer', payload);
};

// Supplier Management
export const getSupplier = (payload = {}) => {
  // Use SessionUserId from payload if provided, otherwise from localStorage
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetSupplier payload:', finalPayload);
  return doPost('/Main/GetSupplier', finalPayload);
};

export const addSupplier = (payload) => {
  console.log('AddSupplier payload:', payload);
  return doPost('/Main/AddSupplier', payload);
};

export const updateSupplier = (payload) => {
  console.log('UpdateSupplier payload:', payload);
  return doPost('/Main/UpdateSupplier', payload);
};

export const deleteSupplier = (payload) => {
  console.log('DeleteSupplier payload:', payload);
  return doPost('/Main/DeleteSupplier', payload);
};

export const getShipment = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetShipment payload:', finalPayload);
  return doPost('/Main/GetShipment', finalPayload);
};

export const addShipment = (payload) => {
  console.log('AddShipment payload:', payload);
  return doPost('/Main/AddShipment', payload);
};

export const updateShipment = (payload) => {
  console.log('UpdateShipment payload:', payload);
  return doPost('/Main/UpdateShipment', payload);
};

export const deleteShipment = (payload) => {
  console.log('DeleteShipment payload:', payload);
  return doPost('/Main/DeleteShipment', payload);
};

// Stock Management
export const getStock = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetStock payload:', finalPayload);
  return doPost('/Main/GetStock', finalPayload);
};

export const addStock = (payload) => {
  console.log('AddStock payload:', payload);
  return doPost('/Main/AddStock', payload);
};

export const updateStock = (payload) => {
  console.log('UpdateStock payload:', payload);
  return doPost('/Main/UpdateStock', payload);
};

export const deleteStock = (payload) => {
  console.log('DeleteStock payload:', payload);
  return doPost('/Main/DeleteStock', payload);
};

// Order Management
export const getOrder = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetOrder payload:', finalPayload);
  return doPost('/Main/GetOrder', finalPayload);
};

export const addOrder = (payload) => {
  console.log('AddOrder payload:', payload);
  return doPost('/Main/AddOrder', payload);
};

export const updateOrder = (payload) => {
  console.log('UpdateOrder payload:', payload);
  return doPost('/Main/UpdateOrder', payload);
};

export const deleteOrder = (payload) => {
  console.log('DeleteOrder payload:', payload);
  return doPost('/Main/DeleteOrder', payload);
};

// Order Supplier Management
export const getOrderSupplier = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetOrderSupplier payload:', finalPayload);
  return doPost('/Main/GetOrderSupplier', finalPayload);
};

export const addOrderSupplier = (payload) => {
  console.log('AddOrderSupplier payload:', payload);
  return doPost('/Main/AddOrderSupplier', payload);
};

export const updateOrderSupplier = (payload) => {
  console.log('UpdateOrderSupplier payload:', payload);
  return doPost('/Main/UpdateOrderSupplier', payload);
};

export const deleteOrderSupplier = (payload) => {
  console.log('DeleteOrderSupplier payload:', payload);
  return doPost('/Main/DeleteOrderSupplier', payload);
};

export const getOrderSupplierDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetOrderSupplierDropdown payload:', finalPayload);
  return doPost('/Main/GetOrderSupplierDropdown', finalPayload);
};

// Product Management
export const getProduct = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetProduct payload:', finalPayload);
  return doPost('/Main/GetProduct', finalPayload);
};

export const addProduct = (payload) => {
  console.log('AddProduct payload:', payload);
  return doPost('/Main/AddProduct', payload);
};

export const updateProduct = (payload) => {
  console.log('UpdateProduct payload:', payload);
  return doPost('/Main/UpdateProduct', payload);
};

export const deleteProduct = (payload) => {
  console.log('DeleteProduct payload:', payload);
  return doPost('/Main/DeleteProduct', payload);
};

export const getOrderDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetOrderDropdown payload:', finalPayload);
  return doPost('/Main/GetOrderDropdown', finalPayload);
};

export const generateFabcoGuid = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GenerateFabcoGuid payload:', finalPayload);
  return doPost('/Main/GenerateFabcoGuid', finalPayload);
};

export const getOrderDetails = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetOrderDetails payload:', finalPayload);
  return doPost('/Main/GetOrderDetails', finalPayload);
};

export const orderAction = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  return doPost('/Main/OrderAction', finalPayload);
};

export const updateSwapStock = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  return doPost('/Main/UpdateSwapStock', finalPayload);
};

export const updateSwapShipment = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  return doPost('/Main/UpdateSwapShipment', finalPayload);
};

export const getOrderActionDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetOrderActionDropdown payload:', finalPayload);
  return doPost('/Main/GetOrderActionDropdown', finalPayload);
};

export const getProductDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetProductDropdown payload:', finalPayload);
  return doPost('/Main/GetProductDropdown', finalPayload);
};

export const getProductDetail = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetProductDetail payload:', finalPayload);
  return doPost('/Main/GetProductDetail', finalPayload);
};

export const getShipmentDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetShipmentDropdown payload:', finalPayload);
  return doPost('/Main/GetShipmentDropdown', finalPayload);
};

export const getStockDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetStockDropdown payload:', finalPayload);
  return doPost('/Main/GetStockDropdown', finalPayload);
};

export const getSupplierDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetSupplierDropdown payload:', finalPayload);
  return doPost('/Main/GetSupplierDropdown', finalPayload);
};

// Reports - Customer Agreement
export const getCustomerAgreementDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetCustomerAgreementDropdown payload:', finalPayload);
  return doPost('/Main/GetCustomerAgreementDropdown', finalPayload);
};

export const getCustomerAgreement = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetCustomerAgreement payload:', finalPayload);
  return doPost('/Main/GetCustomerAgreement', finalPayload);
};

// Reports - Caglik (Warp and Weft Color Reports)
export const getReportingWeaveDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetReportingWeaveDropdown payload:', finalPayload);
  return doPost('/Definition/GetReportingWeaveDropdown', finalPayload);
};

export const getWeave = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetWeave payload:', finalPayload);
  return doPost('/Definition/GetWeave', finalPayload);
};

// Mevcut endpoints.js dosyasına eklenecek/güncellenecek Weave endpoints

// Weave Management - Güncellenmiş fonksiyonlar
export const getWeaves = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetWeaves payload:', finalPayload);
  return doPost('/Definition/GetWeave', finalPayload);
};

export const getWeaveDetail = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetWeaveDetail payload:', finalPayload);
  return doPost('/Definition/GetWeave', finalPayload);
};


export const deleteWeave = (payload) => {
  console.log('DeleteWeave payload:', payload);
  return doPost('/Definition/DeleteWeave', payload);
};

export const copyWeave = (payload) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('CopyWeave payload:', finalPayload);
  return doPost('/Definition/CopyWeave', finalPayload);
};

// WeaveColor Management - Güncellenmiş fonksiyonlar
export const getWeaveColors = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetWeaveColors payload:', finalPayload);
  return doPost('/Definition/GetWeaveColor', finalPayload);
};

export const createWeaveColor = (payload) => {
  // WeftWeight or WaftWeight is provided by caller based on ThreadType.
  const cleanPayload = {
    SessionUserId: payload.SessionUserId,
    PrdWeavesGuid: payload.PrdWeavesGuid,
    PrdYarnGuid: payload.PrdYarnGuid,
    PrdColorGuid: payload.PrdColorGuid,
    Position: payload.Position,
    ThreadCount: payload.ThreadCount,
    ThreadType: payload.ThreadType,
    RowSorting: payload.RowSorting,
    WeftWeight: payload.WeftWeight,
    WaftWeight: payload.WaftWeight,
  };

  console.log('CreateWeaveColor cleaned payload:', cleanPayload);
  return doPost('/Definition/AddWeaveColor', cleanPayload);
};

export const updateWeaveColor = (payload) => {
  // WeftWeight or WaftWeight is provided by caller based on ThreadType.
  const cleanPayload = {
    SessionUserId: payload.SessionUserId,
    WeaveColorId: payload.WeaveColorId,
    PrdWeavesGuid: payload.PrdWeavesGuid,
    PrdColorGuid: payload.PrdColorGuid,
    Position: payload.Position,
    ThreadCount: payload.ThreadCount,
    ThreadType: payload.ThreadType,
    PrdYarnGuid: payload.PrdYarnGuid,
    RowSorting: payload.RowSorting,
    WeftWeight: payload.WeftWeight,
    WaftWeight: payload.WaftWeight,
  };

  console.log('UpdateWeaveColor cleaned payload:', cleanPayload);
  return doPost('/Definition/UpdateWeaveColor', cleanPayload);
};

export const deleteWeaveColor = (payload) => {
  console.log('DeleteWeaveColor payload:', payload);
  return doPost('/Definition/DeleteWeaveColor', payload);
};

// WeaveFactor Management - MainController endpoints
export const getWeaveFactors = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetWeaveFactors payload:', finalPayload);
  return doPost('/Main/GetWeaveFactor', finalPayload);
};

export const createWeaveFactor = (payload) => {
  console.log('CreateWeaveFactor payload:', payload);
  return doPost('/Main/AddWeaveFactor', payload);
};

export const updateWeaveFactor = (payload) => {
  console.log('UpdateWeaveFactor payload:', payload);
  return doPost('/Main/UpdateWeaveFactor', payload);
};

export const deleteWeaveFactor = (payload) => {
  console.log('DeleteWeaveFactor payload:', payload);
  return doPost('/Main/DeleteWeaveFactor', payload);
};

// WeaveDropdown - Mevcut fonksiyon (değişiklik yok)
export const getWeaveDropdown = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetWeaveDropdown payload:', finalPayload);
  return doPost('/Definition/GetWeaveDropdown', finalPayload);
};


// Fixed endpoints - Remove request wrapper

export const updateWeave = (payload) => {
  // Remove fields that don't exist in swagger API for update, but keep TotalThreads
  const cleanPayload = { ...payload };
  delete cleanPayload.WarpPrdYarnGuid;
  delete cleanPayload.WeftPrdYarnGuid;
  delete cleanPayload.WaftWeight;
  delete cleanPayload.WeftWeight;

  // Ensure TotalThreads is string
  if (cleanPayload.TotalThreads) {
    cleanPayload.TotalThreads = cleanPayload.TotalThreads.toString();
  }

  // Ensure other numeric fields are strings
  if (cleanPayload.WarpDensity) {
    cleanPayload.WarpDensity = cleanPayload.WarpDensity.toString();
  }
  if (cleanPayload.WeftDensity) {
    cleanPayload.WeftDensity = cleanPayload.WeftDensity.toString();
  }
  if (cleanPayload.ReedWidth) {
    cleanPayload.ReedWidth = cleanPayload.ReedWidth.toString();
  }
  if (cleanPayload.ReedNo) {
    cleanPayload.ReedNo = cleanPayload.ReedNo.toString();
  }
  if (cleanPayload.Dgts) {
    cleanPayload.Dgts = cleanPayload.Dgts.toString();
  }

  // DON'T wrap in request object - send directly
  console.log('UpdateWeave cleaned payload:', cleanPayload);
  return doPost('/Definition/UpdateWeave', cleanPayload);
};

export const createWeave = (payload) => {
  // Remove fields that don't exist in swagger API for creation
  const cleanPayload = { ...payload };
  delete cleanPayload.WarpPrdYarnGuid;
  delete cleanPayload.WeftPrdYarnGuid;
  delete cleanPayload.WaftWeight;
  delete cleanPayload.WeftWeight;
  // Ensure TotalThreads is string
  if (cleanPayload.TotalThreads) {
    cleanPayload.TotalThreads = cleanPayload.TotalThreads.toString();
  }

  // Ensure numeric fields are strings for API
  if (cleanPayload.WarpDensity) {
    cleanPayload.WarpDensity = cleanPayload.WarpDensity.toString();
  }
  if (cleanPayload.WeftDensity) {
    cleanPayload.WeftDensity = cleanPayload.WeftDensity.toString();
  }
  if (cleanPayload.ReedWidth) {
    cleanPayload.ReedWidth = cleanPayload.ReedWidth.toString();
  }
  if (cleanPayload.ReedNo) {
    cleanPayload.ReedNo = cleanPayload.ReedNo.toString();
  }
  if (cleanPayload.Dgts) {
    cleanPayload.Dgts = cleanPayload.Dgts.toString();
  }

  // DON'T wrap in request object - send directly
  console.log('CreateWeave cleaned payload:', cleanPayload);
  return doPost('/Definition/AddWeave', cleanPayload);
};

// Sample Management
export const getSample = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetSample payload:', finalPayload);
  return doPost('/Main/GetSample', finalPayload);
};

export const getSampleListWithFilter = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = {
    SessionUserId: sessionUserId,
    SampleId: payload.SampleId || null,
    CardNo: payload.CardNo || null,
    CompanyName: payload.CompanyName || null,
    CompositionGuid: payload.CompositionGuid || null,
    WeaveTypeGuid: payload.WeaveTypeGuid || null,
    CurrencyGuid: payload.CurrencyGuid || null,
    Price: payload.Price || null,
    MinFabricWidth: payload.MinFabricWidth || null,
    MaxFabricWidth: payload.MaxFabricWidth || null,
    MinFabricWeight: payload.MinFabricWeight || null,
    MaxFabricWeight: payload.MaxFabricWeight || null,
    StartDate: payload.StartDate || null,
    EndDate: payload.EndDate || null,
    OrderBy: payload.OrderBy || 'date',
    IsDescending: payload.IsDescending !== undefined ? payload.IsDescending : true,
    PageNumber: payload.PageNumber || 1,
    PageSize: payload.PageSize || 10
  };
  console.log('GetSample (filtered) payload:', finalPayload);
  return doPost('/Main/GetSample', finalPayload);
};

export const addSample = (payload) => {
  console.log('AddSample payload:', payload);
  return doPost('/Main/AddSample', payload);
};

export const updateSample = (payload) => {
  console.log('UpdateSample payload:', payload);
  return doPost('/Main/UpdateSample', payload);
};

export const deleteSample = (payload) => {
  console.log('DeleteSample payload:', payload);
  return doPost('/Main/DeleteSample', payload);
};

export const getSampleDropdown = (payload = {}) => {
  const sessionUserId = payload.SessionUserId || localStorage.getItem('sessionUserId');
  const finalPayload = { ...payload, SessionUserId: sessionUserId };
  console.log('GetSampleDropdown payload:', finalPayload);
  return doPost('/Main/GetSampleDropdown', finalPayload);
};

// SampleColor Management
export const getSampleColors = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = {
    SessionUserId: payload.SessionUserId || sessionUserId,
    PrdSampleGuid: payload.PrdSampleGuid ? payload.PrdSampleGuid.toString() : ''
  };
  console.log('📤 GetSampleColors payload:', finalPayload);
  return doPost('/Main/GetSampleColor', finalPayload);
};

export const addSampleColor = (payload) => {
  const cleanPayload = {
    SessionUserId: payload.SessionUserId,
    PrdSampleGuid: payload.PrdSampleGuid,
    PrdYarnGuid: payload.PrdYarnGuid,
    PrdColorGuid: payload.PrdColorGuid,
    Position: payload.Position,
    ThreadCount: payload.ThreadCount,
    ThreadType: payload.ThreadType,
    SampleRowSorting: payload.SampleRowSorting,
    WeftWeight: payload.WeftWeight,
    WaftWeight: payload.WaftWeight,
  };
  console.log('AddSampleColor payload:', cleanPayload);
  return doPost('/Main/AddSampleColor', cleanPayload);
};

export const updateSampleColor = (payload) => {
  const cleanPayload = {
    SessionUserId: payload.SessionUserId,
    SampleColorId: payload.SampleColorId,
    PrdSampleGuid: payload.PrdSampleGuid,
    PrdColorGuid: payload.PrdColorGuid,
    Position: payload.Position,
    ThreadCount: payload.ThreadCount,
    ThreadType: payload.ThreadType,
    PrdYarnGuid: payload.PrdYarnGuid,
    SampleRowSorting: payload.SampleRowSorting,
    WeftWeight: payload.WeftWeight,
    WaftWeight: payload.WaftWeight,
  };
  console.log('UpdateSampleColor payload:', cleanPayload);
  return doPost('/Main/UpdateSampleColor', cleanPayload);
};

export const deleteSampleColor = (payload) => {
  console.log('DeleteSampleColor payload:', payload);
  return doPost('/Main/DeleteSampleColor', payload);
};

export const getSampleColorDropdown = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetSampleColorDropdown payload:', finalPayload);
  return doPost('/Main/GetSampleColorDropdown', finalPayload);
};

// SampleFactor Management
export const getSampleFactors = (payload = {}) => {
  const sessionUserId = localStorage.getItem('sessionUserId');
  const finalPayload = { SessionUserId: sessionUserId, ...payload };
  console.log('GetSampleFactors payload:', finalPayload);
  return doPost('/Main/GetSampleFactor', finalPayload);
};

export const createSampleFactor = (payload) => {
  console.log('CreateSampleFactor payload:', payload);
  return doPost('/Main/AddSampleFactor', payload);
};

export const updateSampleFactor = (payload) => {
  console.log('UpdateSampleFactor payload:', payload);
  return doPost('/Main/UpdateSampleFactor', payload);
};

export const deleteSampleFactor = (payload) => {
  console.log('DeleteSampleFactor payload:', payload);
  return doPost('/Main/DeleteSampleFactor', payload);
};

// CreateWeaveFromSample - Analizden ürün oluştur
export const createWeaveFromSample = (payload) => {
  console.log('CreateWeaveFromSample payload:', payload);
  return doPost('/Main/CreateWeaveFromSample', payload);
};
